import { ComponentProps } from "react"

import { cn } from "@/lib/utils"

import * as Section from "./Section"

export interface BaseSectionProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
  children: React.ReactNode
  ref?: React.Ref<HTMLDivElement>
}

export const Root = Section.Root

export function Header({
  className,
  children,
  bg = "haze",
  ref,
  ...props
}: BaseSectionProps & { bg?: "white" | "haze" }) {
  return (
    <Section.Header ref={ref} className={cn("p-5", className)} bg={bg} {...props}>
      {children}
    </Section.Header>
  )
}

export function Title({
  className,
  children,
  ref,
  ...props
}: ComponentProps<"span"> & { ref?: React.Ref<HTMLHeadingElement> }) {
  return (
    <span
      ref={ref}
      className={cn("row-start-1 text-h2 text-foreground", className)}
      {...props}
    >
      {children}
    </span>
  )
}

export function Subtitle({
  className,
  children,
  ref,
  ...props
}: ComponentProps<"span"> & { ref?: React.Ref<HTMLHeadingElement> }) {
  return (
    <span
      ref={ref}
      className={cn("row-start-2 text-body1 text-muted-foreground", className)}
      {...props}
    >
      {children}
    </span>
  )
}

export function Body({ className, children, ref, ...props }: BaseSectionProps) {
  return (
    <Section.Body ref={ref} className={cn("bg-transparent", className)} {...props}>
      {children}
    </Section.Body>
  )
}

export const Actions = Section.Actions
